module.exports = __webpack_public_path__ + "assets/img/conecta_horizontal.4e0c1008.png";